<template>
    <div>
        <div class="top">
            <van-nav-bar title="高校视频" left-text="返回" left-arrow @click-left="onClickLeft" />
        </div>
        <div class="video-list" v-for="(item,index) in videoList" :key="index">
            <div class="title">{{item.name}}</div>
            <video
                src="http://1256464449.vod2.myqcloud.com/840c2b4fvodcq1256464449/239c2a0f5285890790976316050/MzIOr2XOzmoA.mp4"
               
                controls
            ></video>
            <div class="create-time">{{item.create_time}}</div>
            <div class="nums">播放 {{item.hits}}</div>
        </div>
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";

export default {
    name: "schoolVideo",
    data() {
        return {
            videoList: []
        };
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        loadInfo() {
            httpPost("/saas/lists", {
                schoolid: this.$route.query.id,
                mark: 5
            }).then(response => {
                if (response.code === 1) {
                    this.videoList = response.data;
                }
            });
        }
    },
    mounted() {
        this.loadInfo();
    }
};
</script>

<style scoped>
.video-list {
    width: 95vw;
    margin: 0 auto;
}

video {
    width: 100%;
}
.title {
    font-size: 1.2rem;
    padding-top: 0.5rem;
    color: #383838;
    font-weight: 600;
}
.create-time {
    float: left;
    color: #ccc;
    font-size: 0.9rem;
}
.nums {
    float: right;
    color: #ccc;
    font-size: 0.9rem;
}
</style>